import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandingService, UIConfig } from '../../../services/branding.service';
import { firstValueFrom, take } from 'rxjs';
@Component({
  selector: 'd-header',
  standalone: true,
  imports: [],
  templateUrl: './d-header.component.html',
  styleUrl: './d-header.component.scss',
})
export class DHeaderComponent implements OnInit{

  logoUrl = '';
  clientName = '';

  private router: Router = inject(Router);
  private uiConfigSv: BrandingService = inject(BrandingService);
  private elementRef: ElementRef = inject(ElementRef);

  ngOnInit(): void {
    this.uiConfig();
  }

  private setHeaderColor(config: UIConfig) {
    const hostEl = document.querySelector('header');
    hostEl?.style.setProperty('--bg-header', config.colors.primary);
    hostEl?.style.setProperty('--header-text', config.colors.secondary);
    this.elementRef.nativeElement.style.setProperty('--bg-image', `url(${config.assets.background})`);
}

private uiConfig() {
    this.router.routerState.root.queryParams.subscribe(async res => {
      if('client_id' in res) {
        const uiConfig = await firstValueFrom(this.uiConfigSv.getUiConfig(res['client_id']));
        this.clientName = uiConfig.client.name;
        this.uiConfigSv.setUiConfig(JSON.stringify(uiConfig));
        this.logoUrl = uiConfig.assets.logo;
        this.setHeaderColor(uiConfig);
      }
    })
}

}
